import React, { Component, createRef } from "react";
import UserSearchSection from "./UserSearchSection";
import { Tabs, Tab, TabPanel, TabList } from "react-web-tabs";
import "../../assets/scss/userSetting.scss";
import { axiosPost } from "../../utils/AxiosApi";
import { draggable, URL } from "../../utils/Constants";
import ForgetPasswordRequestUser from "./ForgetPasswordRequestUser";
import ModalWindow from "../UI/ModalWindow";
import UpdatePasswordModal from "./UpdatePasswordModal";
import AllUsers from "./AllUsers";
import swal from "sweetalert";
import { Spinner } from "reactstrap";

class UserSetting extends Component {
  state = {
    statuses: ["pending", "updated", "rejected"],
    enableStatus: [
      { name: "Enabled User", value: true },
      { name: "Disabled User", value: false },
    ],
    activeStatus: [
      { name: "All Users", value: "" },
      { name: "Has LoggedIn", value: true },
      { name: "Never LoggedIn", value: false },
    ],
    active: "",
    status: "",
    enabled: "",
    peopleName: "",
    username: "",
    userRole: "",
    userRoles: [],
    forgetPasswordRequestUsers: [],
    requestOffset: 0,
    requestTotalRecords: 0,
    requestRowCountLimit: 7,
    requestCurrentPage: 1,
    displayRequestSpinner: false,
    search: false,
    allUsers: [],
    allUserOffset: 0,
    allUserTotalRecords: 0,
    allUserRowCountLimit: 10,
    allUserCurrentPage: 1,
    displayAllUserSpinner: false,
    forgotModal: false,
    selectedUsername: "",
    selectedId: "",
    selectedTabId: "allUser",
    bulkLoading: false,
    searchLoading: false,
  };

  allUserRef = createRef();

  componentDidMount() {
    this.getForgetPasswordUsers();
    this.getAllUsers();
    this.getUserRoles();
  }

  getUserRoles = () => {
    axiosPost(URL.getUserRoles, {}, (response) => {
      if (response.status === 200) {
        this.setState({ userRoles: response.data.data });
      }
    });
  };

  getAllUsers = (action) => {
    let data = {
      offset: this.state.allUserOffset,
      rowCountLimit: this.state.allUserRowCountLimit,
    };
    if (action !== "paginate") {
      this.setState({ allUserCurrentPage: 1, allUserOffset: 0 });
    }
    this.setState({ displayAllUserSpinner: true }, function () {
      axiosPost(
        URL.getAllUsers,
        data,
        (response) => {
          if (response.status === 200) {
            this.setState({
              allUsers: response.data.data,
              allUserTotalRecords: response.data.totalRecordsCount,
              displayAllUserSpinner: false,
            });
          }
        },
        (error) => {
          this.setState({ displayAllUserSpinner: false });
        }
      );
    });
  };

  getForgetPasswordUsers = (action) => {
    let data = {
      offset: this.state.requestOffset,
      rowCountLimit: this.state.requestRowCountLimit,
    };
    if (action !== "paginate") {
      this.setState({ requestCurrentPage: 1, requestOffset: 0 });
    }
    this.setState({ displayRequestSpinner: true }, function () {
      axiosPost(
        URL.getForgetPasswordRequestUsers,
        data,
        (response) => {
          if (response.status === 200) {
            this.setState({
              forgetPasswordRequestUsers: response.data.data,
              requestTotalRecords: response.data.totalRecordsCount,
              displayRequestSpinner: false,
            });
          }
        },
        (error) => {
          this.setState({ displayRequestSpinner: false });
        }
      );
    });
  };

  handleChange = (e) => {
    let name = e.target.name,
      value = e.target.value;
    this.setState({ [name]: value }, () => {
      console.log(this.state.active);
    });
  };

  //Search User Setting

  handleSearch = () => {
    this.setState(
      {
        requestOffset: 0,
        requestCurrentPage: 1,
        allUserOffset: 0,
        allUserCurrentPage: 1,
        search: true,
        displayRequestSpinner: true,
        displayAllUserSpinner: true,
      },
      function () {
        this.requestSearch();
        this.allSearch();
        this.allUserRef.current.clearCheckedInput();
      }
    );
  };

  allSearch = () => {
    let data = {
      username: this.state.username,
      userRoleCode: this.state.userRole,
      peopleName: this.state.peopleName,
      enabled: this.state.enabled,
      isActivated: this.state.active === "" ? null : this.state.active,
      offset: 0,
      rowCountLimit: this.state.allUserRowCountLimit,
    };
    let loading = true;
    this.searchAllUsers(data, loading);
  };

  requestSearch = () => {
    let data = {
      username: this.state.username,
      userRoleCode: this.state.userRole,
      peopleName: this.state.peopleName,
      status: this.state.status,
      offset: 0,
      rowCountLimit: 7,
    };
    this.searchForgetRequestUsers(data);
  };

  searchForgetRequestUsers = (data) => {
    this.setState({ seachLoading: true });

    axiosPost(
      URL.getForgetPasswordRequestUsers,
      data,
      (response) => {
        this.setState({
          forgetPasswordRequestUsers: response.data.data,
          requestTotalRecords: response.data.totalRecordsCount,
          displayRequestSpinner: false,
        });
        this.setState({ seachLoading: false });
      },
      (error) => {
        this.setState({ displayRequestSpinner: false });
        this.setState({ seachLoading: false });
      }
    );
  };

  searchAllUsers = (data, loading = false) => {
    this.setState({ searchLoading: loading});
    axiosPost(
      URL.getAllUsers,
      data,
      (response) => {
        this.setState({
          allUsers: response.data.data,
          allUserTotalRecords: response.data.totalRecordsCount,
          displayAllUserSpinner: false,
          searchLoading: false,
        });
      },
      (error) => {
        this.setState({ searchLoading: false });
        this.setState({ displayAllUserSpinner: false });
      }
    );
  };

  //For ForgetPassword pagiantion
  requestHandlePageChange = (page) => {
    this.reRenderForgetRequest(page);
    this.setState({ requestCurrentPage: page });
  };

  reRenderForgetRequest = (page) => {
    let offset =
      page * parseInt(this.state.requestRowCountLimit) -
      parseInt(this.state.requestRowCountLimit);
    this.setState(
      { displayRequestSpinner: true, requestOffset: offset },
      function () {
        if (this.state.search) {
          let data = {
            username: this.state.username,
            userRoleCode: this.state.userRole,
            peopleName: this.state.peopleName,
            status: this.state.status,
            offset: this.state.requestOffset,
            rowCountLimit: this.state.requestRowCountLimit,
          };
          this.searchForgetRequestUsers(data);
        } else {
          this.getForgetPasswordUsers("paginate");
        }
      }
    );
  };

  requestHandleNextPage = () => {
    let nextPage = this.state.requestCurrentPage + 1;
    if (
      nextPage >
      Math.ceil(
        this.state.requestTotalRecords / this.state.requestRowCountLimit
      )
    )
      return;
    else {
      this.reRenderForgetRequest(nextPage);
      this.setState({ requestCurrentPage: nextPage });
    }
  };

  requestHandlePreviousPage = () => {
    if (this.state.requestCurrentPage !== 1) {
      this.reRenderForgetRequest(this.state.requestCurrentPage - 1);
      this.setState((prevState) => ({
        requestCurrentPage: prevState.requestCurrentPage - 1,
      }));
    }
  };

  //forAllUserPagination
  allUserHandlePageChange = (page) => {
    this.reRenderAllUsers(page);
    this.setState({ allUserCurrentPage: page });
  };

  reRenderAllUsers = (page) => {
    let offset =
      page * parseInt(this.state.allUserRowCountLimit) -
      parseInt(this.state.allUserRowCountLimit);
    this.setState(
      {
        displayAllUserSpinner: true,
        allUserOffset: offset,
      },
      function () {
        if (this.state.search) {
          let data = {
            username: this.state.username,
            userRoleCode: this.state.userRole,
            peopleName: this.state.peopleName,
            enabled: this.state.enabled,
            isActivated: this.state.active === "" ? null : this.state.active,

            offset: this.state.allUserOffset,
            rowCountLimit: this.state.allUserRowCountLimit,
          };
          this.searchAllUsers(data);
        } else {
          this.getAllUsers("paginate");
        }
      }
    );
  };

  allUserHandleNextPage = () => {
    let nextPage = this.state.allUserCurrentPage + 1;
    if (
      nextPage >
      Math.ceil(
        this.state.allUserTotalRecords / this.state.allUserRowCountLimit
      )
    )
      return;
    else {
      this.reRenderAllUsers(nextPage);
      this.setState({ allUserCurrentPage: nextPage });
    }
  };

  allUserHandlePreviousPage = () => {
    if (this.state.allUserCurrentPage !== 1) {
      this.reRenderAllUsers(this.state.allUserCurrentPage - 1);
      this.setState((prevState) => ({
        allUserCurrentPage: prevState.allUserCurrentPage - 1,
      }));
    }
  };
  //

  togalForgotModal = (username, id) => {
    this.setState({ forgotModal: !this.state.forgotModal });
    if (username) {
      this.setState({ selectedUsername: username, selectedId: id });
    }
  };

  changeTab = (tabId) => {
    this.setState({ selectedTabId: tabId, enabled: "", status: "" });
  };

  enableDisableUser = (id, status) => {
    let data = {
      id: id,
      enabled: status,
    };
    axiosPost(URL.enableDisableUser, data, (response) => {
      if (response.status === 200) {
        swal({
          title: "Success",
          text: `User ${status ? "enabled" : "disabled"}`,
          closeOnClickOutside: false,
          allowOutsideClick: false,
        });
        draggable();
        this.getAllUsers();
      }
    });
  };

  rejectPassword = (username, id) => {
    let data = {
      username: username,
      id: id,
    };
    axiosPost(URL.rejectPassword, data, (response) => {
      if (response.status === 200) {
        swal({
          title: "Success",
          text: "Password Update request rejected",
          closeOnClickOutside: false,
          allowOutsideClick: false,
        });
        draggable();
        this.getForgetPasswordUsers();
      }
    });
  };

  generateCredentials = (params) => {
    this.setState({ bulkLoading: true });
    axiosPost(
      URL.generateCredentials,
      params,
      (response) => {
        if (response.status === 200) {
          this.setState({ bulkLoading: false });

          const url = response.data.path;
          const path = url.startsWith("/") ? url.slice(1) : url;
          window.open(URL.fileDownloadURL + path, "_blank");

          this.allUserRef.current.clearCheckedInput();
        }
      },
      (error) => {
        this.setState({ bulkLoading: false });
        swal(
          "Oops",
          error.response.data.message || "Failed to generate credentials"
        );
      }
    );
  };

  handleSelectChange = (e) => {
    const value = e.target.value;
    this.setState({ allUserRowCountLimit: parseInt(value) }, () => {
      this.getAllUsers();
    });
  };

  render() {
    return (
      <div className="tt-widgetContent-tab-holder" style={{ height: "80.5vh" }}>
        <UserSearchSection
          active={this.state.active}
          activeStatus={this.state.activeStatus}
          statuses={this.state.statuses}
          status={this.state.status}
          enabled={this.state.enabled}
          peopleName={this.state.peopleName}
          username={this.state.username}
          userRole={this.state.userRole}
          userRoles={this.state.userRoles}
          handleChange={this.handleChange}
          handleSearch={this.handleSearch}
          selectedTabId={this.state.selectedTabId}
          enableStatus={this.state.enableStatus}
          searchLoading={this.state.searchLoading}
        ></UserSearchSection>
        <div className="tt-postTabs tt-inner-content">
          {this.state.selectedTabId === "allUser" && (
            <button
              style={{ width: "210px" }}
              onClick={() => this.allUserRef.current.handleBulkResend()}
              disabled={this.state.bulkLoading}
              className="bulk-resend-button tt-button tt-button-primary mr-3"
            >
              {this.state.bulkLoading ? (
                <Spinner size={"sm"} color="white"></Spinner>
              ) : (
                "Bulk Resend Credentials"
              )}
            </button>
          )}
          <Tabs
            onChange={(tabId) => this.changeTab(tabId)}
            className="tt-userSetting"
          >
            <TabList style={{ marginBottom: "0 !important" }}>
              <Tab tabFor="allUser">All Users</Tab>
              <Tab tabFor="fogetPasswordRequest">Forgot Password Requests</Tab>
            </TabList>
            <TabPanel tabId="allUser" style={{ height: "58vh" }}>
              <AllUsers
                ref={this.allUserRef}
                allUserOffset={this.state.allUserOffset}
                allUserTotalRecords={this.state.allUserTotalRecords}
                allUserCurrentPage={this.state.allUserCurrentPage}
                allUserRowCountLimit={this.state.allUserRowCountLimit}
                allUserHandlePageChange={this.allUserHandlePageChange}
                allUserHandleNextPage={this.allUserHandleNextPage}
                allUserHandlePreviousPage={this.allUserHandlePreviousPage}
                toggleForgotModal={this.togalForgotModal}
                displayAllUserSpinner={this.state.displayAllUserSpinner}
                allUsers={this.state.allUsers}
                enableDisableUser={this.enableDisableUser}
                handleSelectChange={this.handleSelectChange}
                generateCredentials={this.generateCredentials}
              ></AllUsers>
            </TabPanel>
            <TabPanel tabId="fogetPasswordRequest" style={{ height: "59vh" }}>
              <ForgetPasswordRequestUser
                forgetPasswordRequestUsers={
                  this.state.forgetPasswordRequestUsers
                }
                requestOffset={this.state.requestOffset}
                requestTotalRecords={this.state.requestTotalRecords}
                requestCurrentPage={this.state.requestCurrentPage}
                requestRowCountLimit={this.state.requestRowCountLimit}
                requestHandlePageChange={this.requestHandlePageChange}
                requestHandleNextPage={this.requestHandleNextPage}
                requestHandlePreviousPage={this.requestHandlePreviousPage}
                toggleForgotModal={this.togalForgotModal}
                displayRequestSpinner={this.state.displayRequestSpinner}
                rejectPassword={this.rejectPassword}
              ></ForgetPasswordRequestUser>
            </TabPanel>
          </Tabs>
        </div>
        <ModalWindow
          modal={this.state.forgotModal}
          toggleModal={this.togalForgotModal}
          modalHeader="Update New Password"
          modalBody={
            <UpdatePasswordModal
              toggleForgotModal={this.togalForgotModal}
              getForgetPasswordUsers={this.getForgetPasswordUsers}
              selectedUsername={this.state.selectedUsername}
              selectedId={this.state.selectedId}
              getAllUsers={this.getAllUsers}
            ></UpdatePasswordModal>
          }
        ></ModalWindow>
      </div>
    );
  }
}

export default UserSetting;
